import React from "react";
import PublicPage from "@/components/public/PublicPage";
import { SUPPORTED_REGIONS, COMPLIANCE_DISCLAIMER } from "@/lib/compliance-copy";

const steps = [
  { title: "Select a region", desc: "Each business or location selects the region it operates in." },
  { title: "Apply the law pack", desc: "The supported regional law pack, guidance and procedures are loaded for that location." },
  { title: "Review changes", desc: "When a supported requirement changes, the update is presented for review before it is applied." },
  { title: "Keep the record", desc: "Applied updates are recorded so you can show what changed and when." },
];

export default function RegionalCompliancePublic() {
  return (
    <PublicPage
      eyebrow="Regional Compliance"
      title="Supports Regional Compliance Requirements"
      intro="Crystal HACCP applies region-specific food-safety guidance based on the region selected for each business or location."
    >
      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 py-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {SUPPORTED_REGIONS.map((r) => (
              <div key={r.code} className="app-card p-5">
                <div className="text-white font-semibold">{r.name}</div>
                <p className="text-white/65 text-sm mt-1.5">{r.note}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 py-10">
          <h2 className="heading-app text-2xl md:text-3xl mb-6">How it works</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {steps.map((s, i) => (
              <div key={s.title} className="app-card p-5">
                <div className="app-eyebrow mb-2">Step {i + 1}</div>
                <div className="text-white font-semibold">{s.title}</div>
                <p className="text-white/65 text-sm mt-1.5">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 pb-16">
          <div className="app-card p-6">
            <div className="app-eyebrow mb-2">Important</div>
            <p className="text-white/70 text-sm leading-relaxed">{COMPLIANCE_DISCLAIMER}</p>
          </div>
        </div>
      </section>
    </PublicPage>
  );
}
